import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Button from '../../../UniformComponents/Button'

const DeleteListModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.deleteListModalVisible}
        onClose={distributeStore.hideDeleteListModal}
    >
        <div style={{ textAlign: 'center' }}>
            <Typography type="h3">{i18n.t('deleteListModal.title')}</Typography>

            <br />

            <Typography>{i18n.t('deleteListModal.body')}</Typography>
        </div>

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
                label={i18n.t('cancel')}
                onClick={distributeStore.hideDeleteListModal}
                cssClass="regular tertiary"
            />

            <Button
                label={i18n.t('deleteListModal.confirm')}
                onClick={distributeStore.continueDeleteEmptyList}
                icon="fal fa-circle-xmark"
                cssClass="regular error"
            />
        </div>
    </Modal>
)

export default observer(DeleteListModal)
